import { render, staticRenderFns } from "./stage4.vue?vue&type=template&id=96d208e0&"
import script from "./stage4.vue?vue&type=script&lang=js&"
export * from "./stage4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports